/** Comentario: mismo breakpoint para menú horizontal y hamburguesa del header */
export const HORIZONTAL_MENU_MEDIA = '(min-width: 900px)';
